import { createError, defineNuxtRouteMiddleware } from 'nuxt/app'

/** 允许包含大写字母的路径片段，命中后不触发大写路由 404 校验。 */
export const UPPERCASE_ROUTE_WHITELIST = ['drCommentsDetail', 'commentsList']

/** 判断当前路径是否命中大写路由白名单。 */
const isUppercaseRouteWhitelisted = (path: string) => {
  const pathSegments = path.split('/').filter(Boolean)
  return UPPERCASE_ROUTE_WHITELIST.some((routeSegment) => pathSegments.includes(routeSegment))
}

/** 路径含大写字母时统一跳转到 404 页面，query 参数不参与判断。 */
export default defineNuxtRouteMiddleware((to) => {
  if (/[A-Z]/.test(to.path) && !isUppercaseRouteWhitelisted(to.path)) {
    throw createError({
      statusCode: 404,
      statusMessage: 'Page Not Found',
    })
  }
})
